// extracted by mini-css-extract-plugin
export default {"formItem":"styles_formItem__cVguN","formItemCol":"styles_formItemCol__wH3pH"};